module.exports = __webpack_public_path__ + "static/media/logo.1897cfe8.png";